import React from "react";
import { getCardColor } from "./data";

const EducationUl = ({ descriptionPoints, type }) => {
  return (
    <div className="flex flex-col gap-5 ">
      {descriptionPoints.map((point, index) => (
        <div key={index} className="relative pl-[30px]  ">
          <p className="text-teal-300 text-body-md  rounded-[10px] bg-white z-10 relative  font-medium p-1.5 ml-[-10px]">
            {point}
          </p>
          <div
            className={`absolute top-[8px] right-[8px] w-full  z-0 rounded-[10px] h-full flex items-center ${getCardColor(type)}`}
          >
            <div className="text-white text-xs-display font-bold p-[10px] ">
              <div className="w-[10px] h-[10px] bg-white rounded-full" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EducationUl;
